/* eslint-disable camelcase */
import { useEffect, useRef, useState } from 'react'
import { Collapse as CollapseComponent } from 'react-collapse'

import { Minus, Plus } from '../Icons'
import { CollapseTitle, Container } from './styles'

type CollapseProps = {
  open?: boolean
  title: string
  children: React.ReactNode
}

export const Collapse = ({ title, children, open = false }: CollapseProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const [isOpen, setIsOpen] = useState(open)
  const [height, setHeight] = useState<number>()

  useEffect(() => {
    if (ref.current) {
      setHeight(ref.current.getBoundingClientRect().height)
    }
  }, [])

  return (
    <Container>
      <CollapseTitle onClick={() => setIsOpen((prev) => !prev)} isOpen={isOpen}>
        <span>{title}</span>
        {isOpen ? (
          <Minus color="#333" size={24} />
        ) : (
          <Plus color="#333" size={24} />
        )}
      </CollapseTitle>
      <CollapseComponent isOpened={isOpen} style={{ height }}>
        <div ref={ref} className="collapse-content">
          {children}
        </div>
      </CollapseComponent>
    </Container>
  )
}
